function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.2998 33.1C37.4998 33.1 34.3998 36.2 34.3998 40C34.3998 43.8 37.4998 46.9 41.2998 46.9C41.2998 41.8 41.2998 43.8 41.2998 40C41.2998 36.2 41.2998 36.9 41.2998 33.1ZM32.2998 40C32.2998 35 36.2998 31 41.2998 31C46.2998 31 50.2998 35 50.2998 40C50.2998 45 46.2998 49 41.2998 49C36.2998 49 32.2998 45 32.2998 40Z",
  fill: "#BAA273"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0004 27.9H42.6004C42.9004 27.9 43.2004 27.6 43.2004 27.3V21.1C43.2004 20.8 42.9004 20.5 42.6004 20.5H40.0004C39.7004 20.5 39.4004 20.8 39.4004 21.1V27.3C39.4004 27.6 39.7004 27.9 40.0004 27.9Z",
  fill: "#BAA273"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.0002 32.3999C31.2002 32.5999 31.6002 32.5999 31.9002 32.3999L33.7002 30.5999C33.9002 30.3999 33.9002 29.9999 33.7002 29.6999L29.3002 25.2999C29.1002 25.0999 28.7002 25.0999 28.4002 25.2999L26.6002 27.0999C26.4002 27.2999 26.4002 27.6999 26.6002 27.9999L31.0002 32.3999Z",
  fill: "#BAA273"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1002 41.3001V38.7001C29.1002 38.4001 28.8002 38.1001 28.5002 38.1001H22.3002C22.0002 38.1001 21.7002 38.4001 21.7002 38.7001V41.3001C21.7002 41.6001 22.0002 41.9001 22.3002 41.9001H28.5002C28.9002 41.9001 29.1002 41.6001 29.1002 41.3001Z",
  fill: "#BAA273"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.8006 47.6C31.6006 47.4 31.2006 47.4 30.9006 47.6L26.5006 52C26.3006 52.2 26.3006 52.6 26.5006 52.9L28.3006 54.7C28.5006 54.9 28.9006 54.9 29.2006 54.7L33.6006 50.3C33.8006 50.1 33.8006 49.7 33.6006 49.4L31.8006 47.6Z",
  fill: "#BAA273"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M42.4998 52.1001H39.8998C39.5998 52.1001 39.2998 52.4001 39.2998 52.7001V58.9001C39.2998 59.2001 39.5998 59.5001 39.8998 59.5001H42.4998C42.7998 59.5001 43.0998 59.2001 43.0998 58.9001V52.7001C43.0998 52.4001 42.8998 52.1001 42.4998 52.1001Z",
  fill: "#BAA273"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M40 3C60.4 3 77 19.6 77 40C77 60.4 60.4 77 40 77C19.6 77 3 60.4 3 40C3 19.6 19.6 3 40 3ZM40 0C17.9 0 0 17.9 0 40C0 62.1 17.9 80 40 80C62.1 80 80 62.1 80 40C80 17.9 62.1 0 40 0Z",
  fill: "#BAA273"
});

var SvgLightHalf = function SvgLightHalf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightHalf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/light-half.3c2604ba.svg";
export { ForwardRef as ReactComponent };